import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { cashpaymentApi } from 'src/app/config/api-url';

@Injectable({
  providedIn: 'root'
})
export class CashpaymentService {

  constructor(private apiService: ApiService) { }

  getVendorLevelStatus(){
    return this.apiService.get(`${cashpaymentApi.getVendorLevelStatus}`)
  }

  getVendorLevelGridData(reqParam){
    return this.apiService.get(`${cashpaymentApi.getVendorData}${reqParam}`)
  }

  getPartnerLevelStatusList(){
    return this.apiService.get(`${cashpaymentApi.getPartnerLevelStatus}`)
  }

  getVendorLevelBreakdownTableData(reqParam){
    return this.apiService.get(`${cashpaymentApi.getVendorLevelBreakdownData}${reqParam}`) 
  }

  getListofCashPaymentByPartner(reqParam){
    return this.apiService.get(`${cashpaymentApi.getCashpaymentByPartner}${reqParam}`) 
  }

  getcashpaymentVendorLevelStatusHistory(req){
    return this.apiService.get(`${cashpaymentApi.getcashpaymentVendorlevelStatusHistory}${req}`) 
  }

  getcashPaymentPartnerLevelStatusHistory(req){
    return this.apiService.get(`${cashpaymentApi.getcashpaymentPartnerLevelStatusHistory}${req}`)
  }

  getByPartnerBreakdownData(req){
    return this.apiService.get(`${cashpaymentApi.getByPartnerBreakdownList}${req}`)
  }
  updateStatusOfCashpaymentAtVendorLeavel(req){
    return this.apiService.postCompleteResponse(`${cashpaymentApi.updateStatusOfCashpaymentAtVendorLevel}`,req)
  }

  downloadPaymentFile(req){
    return this.apiService.get(`${cashpaymentApi.downloadPaymentFile}${req}`)
  }

  uploadVistexPaymentFile(fileData){
    return this.apiService.postForFileUpload(`${cashpaymentApi.uploadVistexPaymentFIle}`,fileData)
  }

  getListOfPartnerConsolidatedData(req){
    return this.apiService.get(`${cashpaymentApi.getPartnerConsolidatedList}${req}`)
  }
  getPartnerLeaderBreakdownData(req){
    return this.apiService.get(`${cashpaymentApi.getPartnerLeaderBreakdownData}${req}`)
  }

  getStatusHistoryOfConsolidatedCashpaymentData(req){
    return this.apiService.get(`${cashpaymentApi.getPartnerLeaderStatusHistory}${req}`)
  }

  getPartnerConsolidatedBreakdownRunData(req){
    return this.apiService.get(`${cashpaymentApi.getPartnerConsolidatedBreakdownRun}${req}`)
  }

  submitProofOfPayment(req){
    return this.apiService.post(`${cashpaymentApi.postSubmitProofOfPayment}`,req)
  }

  getSellerlevelCashData(req){
    return this.apiService.get(`${cashpaymentApi.getByuserConsolidatedData}${req}`)
  }

  getSellerStatusList(){
    return this.apiService.get(`${cashpaymentApi.getbyUserStatusList}`)
  }
}
